module.exports = __webpack_public_path__ + "img/text-uppercase.84590e88.svg";